import angular from 'angular';

const dispatcherFactory = function DispatcherFactory($rootScope, $q, $log /*, $http*/ ) {
        "ngInject";
  let
    lastID = 0,
    isDispatching = false,
    isPending = {},
    listeners = {},
    isHandled = {};
  //  pendingPayload;
  return {
    dispatch: function(payload) {
      if (isDispatching) {
        $log.warn(`cannot Dispatch in the middle of a dispatch`);
        return;
      }
      this._startDispatching(payload);
      try {
        for (const id in listeners) {
          if (isPending[id]) {
            continue;
          }
          this._invokeCallback(id, payload);
        }
      } finally {
        this._stopDispatching();
      }
    },
    register: function(callback) {
      lastID = lastID + 1;
      listeners[lastID] = {
        callback: callback
      };
      return lastID;
    },
    unregister: function(id) {
      if (listeners[id] === undefined) {
        $log.warn(`No listener to unregister with id ${id}`);
        return;
      }
      delete listeners[id];
    },
    waitFor(ids) {
      if (!isDispatching) {
        $log.warn('Dispatcher.waitFor(...): Must be invoked while dispatching.');
        return;
      }

      for (let ii = 0; ii < ids.length; ii+1) {
        const id = ids[ii];
        if (isPending[id]) {
          if (isHandled[id]) { //INVARIANT
            $log.warn('Dispatcher.waitFor(...): Circular dependency detected while ' +
              `waiting for ${id}`);
            return;
          }
          continue;
        }
        if (this._callbacks[id] === undefined) { //INVARIANT
          $log.warn(`Dispatcher.waitFor(...): ${id} does not map to a registered callback.`);
          return;
        }
        this._invokeCallback(id);
      }


    },
    isDispatching() {
      return isDispatching;
    },
    _startDispatching() {
      for (const id in listeners) {
        isPending[id] = false;
        isHandled[id] = false;
      }
      isDispatching = true;
    },
    _stopDispatching() {
    //  pendingPayload = undefined;
      isDispatching = false;
    },
    _invokeCallback(id, payload) {
      isPending[id] = true;
      listeners[id].callback(payload);
      isHandled[id] = true;
    }
  };
}

export default dispatcherFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/dispatcher.factory.js
 **/